/* ==========================================================================
   SearcherFlight > Client > Discount
   ========================================================================== */

/* Modules */
const { fromEvent } = require('rxjs');
const { filter } = require('rxjs/operators');

const Input = require('@bluekiri/alexandria-contrib-components/components/input-rxjs/client/js');

const { addPanel } = require('./panel');

const { types, actions } = require('../store/actions');

const configuration = require('../config');

/* Init */
function initDiscount(instance) {
    /* Selector */
    const { selector } = instance;

    const panel = instance;

    /* Reference */
    panel.discount = Input(`${selector} [data-component='InputRxjs'][data-type='${configuration().type.discount}']`);

    if (!panel.discount) return;

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeDiscount: payload => instance.store.dispatch(actions.changeDiscount(payload))
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        changeDiscount: instance.store.subscribe((_, action) => {
            if (action.type !== types.CHANGE_DISCOUNT) return;

            const { label } = action.payload;

            /* Update value UI */
            instance.discount.actions.setValue(label);
        })
    };

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        openDiscountPanel: fromEvent(instance.discount.element, 'click')
            .pipe(filter(() => !instance.discountPanel))
            .subscribe(() => {
                /* Add */
                addPanel(instance, instance.discount.element);
            })
    };

    /* Get value */
    const { bonus } = instance.config;
    const { items } = bonus;
    const value = items.reduce((acc, cur) => (cur.selected ? cur : acc), {});

    /* Sync */
    instance.actions.setSearcher({ discount: value });
}

/* Destroy */
function destroyDiscount(instance) {
    if (!instance.discount) return;

    const panel = instance;

    /* Reference */
    instance.discount.actions.destroy();
    delete panel.discount;

    /* Subscriptions */
    instance.subscriptions.openDiscountPanel.unsubscribe();
    delete panel.subscriptions.openDiscountPanel;
}

/* Exports */
module.exports = {
    initDiscount,
    destroyDiscount
};
